import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Icon } from 'semantic-ui-react';
import IEditIconBtnProps from '../interfaces/IEditIconBtnProps';
import './../styles/button.css';

/** Form Edit Icon Button
 * @description Used to open "edit item" form.
 * @param {string} to - url to the form where user want to enter
 * @param {boolean} [hide] - hide the button
 * @link https://react.semantic-ui.com/elements/button/
 **/
const EditIconBtn: React.FC<IEditIconBtnProps> = (props: IEditIconBtnProps) => {

    const navigate = useNavigate();

    const { to, hidden=false, color, type, ...rest } = props;

    if (hidden) return null;

    return (
        <Button
            icon={<Icon name={'pencil'} />}
            color={color ? color : undefined}
            type={type ? type : 'reset'}
            onClick={() => navigate(to) }
            {...rest}
        />
    );

};

export default EditIconBtn;
